
import { FaFileCode } from 'react-icons/fa'
import { FaArrowUpRightFromSquare } from 'react-icons/fa6'
const PortfolioCard = ({ id, src, codeLink, viewLink, project, technology }) => {
    return (
                <div className='shadow-md w-full sm:hover:shadow-emerald-300 sm:shadow-cyan-500 p-2 rounded-lg sm:border-2 sm:border-cyan-500 hover:scale-95 duration-200 cursor-pointer'>
                    <img src={src} alt="Portfolio" className='rounded-md h-40 w-full object-scale-down' />
                    <div className='flex items-center justify-center'>
                        <a
                            href={codeLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className='w-1/2 px-2 py-1 m-2 duration-200 hover:scale-95 border rounded-md mt-3 flex justify-center items-center gap-2 font-bold hover:bg-white hover:text-gray-900'
                        >
                            Code <FaFileCode />
                        </a>
                        <a
                            href={viewLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className='w-1/2 px-2 py-1 m-2 duration-200 hover:scale-95 border rounded-md mt-3 flex justify-center items-center gap-2 font-bold hover:bg-cyan-400 hover:text-gray-900'
                        >
                            View <FaArrowUpRightFromSquare />
                        </a>
                    </div>
                    <div className='px-2 flex items-center justify-center'>
                        <p className='font-bold text-gray-500'>Topic: <span className='font-medium text-white'>{project ? project : "Working..."}</span></p>
                    </div>

                    <div className='flex flex-wrap gap-1 my-1 justify-center'>
                        {Array.isArray(technology) ? (
                            technology.map((tech, i) => (
                                <span key={i} className="px-2 text-sm rounded-full py-1 bg-gray-700 hover:bg-gray-800 hover:scale-95 duration-200">
                                    {tech}
                                </span>
                            ))
                        ) : (
                            <span className=""></span>
                        )}
                    </div>
                </div>
    )
}

export default PortfolioCard